import { useEffect, useState } from 'react'
import { Link } from 'react-router'

import { api } from '../api/client'
import type { User } from '../api/types'

const Users: React.FC = () => {
  const [users, setUsers] = useState<User[] | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    api
      .listUsers()
      .then(setUsers)
      .catch((e: Error) => setError(e.message))
  }, [])

  return (
    <section>
      <h1 className="mb-4 text-2xl font-semibold">Users</h1>
      {error && (
        <p className="mb-3 rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          {error}
        </p>
      )}
      {users === null ? (
        <p className="text-gray-500">Loading…</p>
      ) : users.length === 0 ? (
        <p className="text-gray-500">No users yet.</p>
      ) : (
        <ul className="divide-y divide-gray-200 rounded border border-gray-200 bg-white">
          {users.map((u) => (
            <li key={u.id} className="flex items-center justify-between px-4 py-3">
              <div>
                <div className="font-medium text-gray-900">{u.name ?? '(no name)'}</div>
                <div className="text-sm text-gray-500">{u.email}</div>
              </div>
              <Link
                to={`/users/${u.id}`}
                className="text-sm text-blue-600 hover:underline"
              >
                View entries →
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}

export default Users
